import { GeocondingInfo } from "../../models/entities/organizations";

export function getResult(results: google.maps.GeocoderResult[]): GeocondingInfo {
  const geocodingInfoList = results.map((result: google.maps.GeocoderResult) => new GeocondingInfo(result));

  for (const geocodingInfo of geocodingInfoList) {
    if (
      geocodingInfo.postalCode &&
      geocodingInfo.locality &&
      geocodingInfo.province &&
      geocodingInfo.bounds &&
      geocodingInfo.positionByPostalCode
    ) {
      return geocodingInfo;
    }
  }
  return geocodingInfoList[0];
}
